export const KNOWLEDGEBASE_IOC_TYPES = {
  DOMAIN_NAME: 'Domain-Name',
  IPV4_ADDR: 'IPv4-Addr',
  SHA256: 'SHA256',
  SHA_256: 'SHA-256',
  SHA1: 'SHA1',
  SHA_1: 'SHA-1',
  MD5: 'MD5'
};

// old enrichment api
export const IOC_TYPES = {
  IPV4: 'ipv4',
  IPV4_ADDR: 'IPv4-Addr',
  DOMAIN: 'domain',
  DOMAIN_NAME: 'Domain-Name',
  URL: 'url',
  SHA_256: 'SHA-256',
  HASH_SHA_256: 'file/sha256'
};

export const IOC_TYPES_NEW = {
  IPV4: 'ipv4',
  IPV6: 'ipv6', // exist only in threat-intel-platform service
  DOMAIN: 'domain',
  URL: 'url',
  MD5: 'md5',
  SHA1: 'sha1',
  HASH_SHA_256: 'sha256'
};

export const IOC_TYPE_TO_FORENSIC_TYPE = {
  url: 'url',
  md5: 'file',
  sha1: 'file',
  sha256: 'file',
  'sha-256': 'file',
  'file/sha256': 'file',
  hash: 'file',
  domain: 'domain',
  'domain-name': 'domain',
  subdomain: 'subdomain',
  'ipv4-addr': 'ip',
  ipv4: 'ip',
  'ipv6-addr': 'ip',
  ipv6: 'ip',
  ip: 'ip'
};

export const IOC_TYPES_TEM = {
  IP: 'IP',
  SHA256: 'SHA256',
  SHA1: 'SHA1',
  MD5: 'MD5',
  DOMAIN: 'DOMAIN',
  URL: 'URL',
  CIDR: 'CIDR',
  SENDER_EMAIL: 'SENDER_EMAIL'
};

export const IOC_UI_STATUS = {
  MALICIOUS: 'malicious',
  BENIGN: 'benign',
  INCONCLUSIVE: 'inconclusive'
};

export const SOURCE_BLOCK_IOC_REQUEST = 'CPEM'; // Check Point External Management

// Map internal IOC types to the block API's expected enum values
export const IOC_TYPE_TO_TEM_IOC_TYPE = {
  [KNOWLEDGEBASE_IOC_TYPES.DOMAIN_NAME]: IOC_TYPES_TEM.DOMAIN,
  [KNOWLEDGEBASE_IOC_TYPES.IPV4_ADDR]: IOC_TYPES_TEM.IP,
  [KNOWLEDGEBASE_IOC_TYPES.SHA256]: IOC_TYPES_TEM.SHA256,
  [KNOWLEDGEBASE_IOC_TYPES.SHA_256]: IOC_TYPES_TEM.SHA256,
  [KNOWLEDGEBASE_IOC_TYPES.SHA1]: IOC_TYPES_TEM.SHA1,
  [KNOWLEDGEBASE_IOC_TYPES.SHA_1]: IOC_TYPES_TEM.SHA1,
  [KNOWLEDGEBASE_IOC_TYPES.MD5]: IOC_TYPES_TEM.MD5,
  [IOC_TYPES_NEW.IPV4]: IOC_TYPES_TEM.IP,
  [IOC_TYPES_NEW.IPV6]: IOC_TYPES_TEM.IP,
  [IOC_TYPES_NEW.DOMAIN]: IOC_TYPES_TEM.DOMAIN,
  [IOC_TYPES_NEW.URL]: IOC_TYPES_TEM.URL,
  [IOC_TYPES_NEW.MD5]: IOC_TYPES_TEM.MD5,
  [IOC_TYPES_NEW.SHA1]: IOC_TYPES_TEM.SHA1,
  [IOC_TYPES_NEW.HASH_SHA_256]: IOC_TYPES_TEM.SHA256
};

export const EXPIRATION = {
  [IOC_TYPES.HASH_SHA_256]: 365,
  [IOC_TYPES_NEW.HASH_SHA_256]: 365,
  [IOC_TYPES.SHA_256]: 365,
  [IOC_TYPES.DOMAIN]: 7,
  [IOC_TYPES.DOMAIN_NAME]: 7,
  [IOC_TYPES.URL]: 7,
  [IOC_TYPES.IPV4]: 1,
  [IOC_TYPES.IPV4_ADDR]: 1
};

export const IOC_TYPE_TO_FEED_TYPE = {
  [KNOWLEDGEBASE_IOC_TYPES.IPV4_ADDR]: IOC_TYPES_NEW.IPV4,
  [KNOWLEDGEBASE_IOC_TYPES.DOMAIN_NAME]: IOC_TYPES_NEW.DOMAIN,
  Url: IOC_TYPES_NEW.URL,
  StixFile: IOC_TYPES_NEW.HASH_SHA_256,
  [KNOWLEDGEBASE_IOC_TYPES.SHA256]: IOC_TYPES_NEW.HASH_SHA_256,
  [KNOWLEDGEBASE_IOC_TYPES.SHA_256]: IOC_TYPES_NEW.HASH_SHA_256,
  [KNOWLEDGEBASE_IOC_TYPES.SHA1]: IOC_TYPES_NEW.SHA1,
  [KNOWLEDGEBASE_IOC_TYPES.SHA_1]: IOC_TYPES_NEW.SHA1,
  [KNOWLEDGEBASE_IOC_TYPES.MD5]: IOC_TYPES_NEW.MD5
};
